// extracted by mini-css-extract-plugin
export default {"container":"_239bcc8aa429dabc","item":"_6aa7b980ecb6df50","buttonRemoveProjects":"_0d3338438e9fbe48","buttonRemoveTemplates":"_41584f4206b23495"};